module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--3--redeem-25f715d9.png";